export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.10-0951.19",
  commitId: "23989013bc1c05a971ef48da68b1085be292f166",
  commitTime: "2026-07-10T09:51:19.000Z",
});
